/* eslint-disable no-mixed-spaces-and-tabs */
import { createSelector } from 'reselect';
import { initialState } from './reducer';

export const selectIcepacksFillersContainerDomain = state => state.icepacksFillersContainerReducer || initialState;

export const getIsIcepacksFillersLoadingSelector = () =>
	createSelector(selectIcepacksFillersContainerDomain, ({ isIcepacksFillersLoading }) => isIcepacksFillersLoading);

export const getIcepacksFillersSelector = () =>
	createSelector(selectIcepacksFillersContainerDomain, ({ icepacksFillers }) => {
		return icepacksFillers;
	});

export const getPaginationSelector = () =>
	createSelector(selectIcepacksFillersContainerDomain, ({ pagination }) => {
		if (!pagination || pagination?.total === 0) {
			return null;
		}

		return {
			currentPage: pagination.current_page,
			totalPages: pagination.last_page,
			perPage: pagination.per_page,
			total: pagination.total,
			from: pagination.current_page * pagination.per_page - (pagination.per_page - 1),
			to:
				pagination.current_page === pagination.last_page
					? pagination.total
					: pagination.current_page * pagination.per_page,
			isNextItem: true,
			isPrevItem: true,
			isLastItem: false,
			isFirstItem: false,
		};
	});
